"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_desktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "411a890a-69be-458f-8374-3da9114667f1",
    x1: 46,
    y1: 30,
    x2: 146,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "21da33be-9ec2-4303-82a8-d45b21482d03",
    x1: 61.88,
    y1: 86.12,
    x2: 151.88,
    y2: 176.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "desktop-hi"), /*#__PURE__*/React.createElement("g", {
    id: "18b836c5-a605-4cc6-8e6b-b4e2ff4c2091",
    "data-name": "desktop-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d9cbe916-93f0-4346-820e-80d854f5271d",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "87b6c388-25b7-4e64-b5de-bcabd3d26ecc",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66f3c7b4-cc38-494c-9ebd-bfa250e01b93",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac581ea0-0eca-4372-8da6-076bdf54f8b5",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2d1f2ff2-b2e4-4860-9c1c-c170c37cd35c",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c5bff826-0bc6-4dc9-825d-39c2eb9f9540",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3de575e4-51ae-4776-a99b-6f056337c17d",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "da5b321e-1e46-4fdb-a4fd-886d137c4f4c",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "43a3681a-fa1b-4cf4-bff1-e837d4165c0a",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e8485b1b-d8c1-46b5-880e-20e8843c2edb",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.06,12H136a0,0,0,0,1,0,0V148a0,0,0,0,1,0,0H60.06A4.06,4.06,0,0,1,56,143.94V16.06A4.06,4.06,0,0,1,60.06,12Z",
    transform: "translate(176 -16) rotate(90)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 152 28 120 164 120 176 152 16 152",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 152 28 120 164 120 176 152 16 152",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 132,
    height: 76,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 128,
    height: 72,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 128,
    height: 72,
    opacity: 0.5,
    fill: "url(#411a890a-69be-458f-8374-3da9114667f1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,152H176a0,0,0,0,1,0,0v4a4,4,0,0,1-4,4H20a4,4,0,0,1-4-4v-4A0,0,0,0,1,16,152Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,152H176a0,0,0,0,1,0,0v4a4,4,0,0,1-4,4H20a4,4,0,0,1-4-4v-4A0,0,0,0,1,16,152Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,158H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4v-2A4,4,0,0,1,172,158Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61 152 28 120 163.5 120 176 152 61 152",
    opacity: 0.2,
    fill: "url(#21da33be-9ec2-4303-82a8-d45b21482d03)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 138,
    width: 47.91,
    height: 4,
    rx: 1.41,
    ry: 1.41,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })))))))))))));
}

var _default = ic_desktop;
exports.default = _default;